import { call, put, select } from 'redux-saga/effects'

import { authSelector } from '@/hooks/useAuth'
import { NestClient } from '@/nest'
import type { AuthState } from '@/types'
import {
  type CommentReadsActions,
  InternalCommentReadsActions,
} from '../actions'
import type { CommentReadsState } from '../types'

export function* list({
  payload: { id },
}: ReturnType<typeof CommentReadsActions.list>) {
  const auth: AuthState = yield select(authSelector)

  if (!auth.authenticated) {
    return
  }

  // Unread marks are decoration over an open project, not a condition of it:
  // a failed request leaves the marks off and the project alone
  try {
    const reads: CommentReadsState = yield call(
      NestClient.projects.commentReads.list,
      id
    )

    yield put(InternalCommentReadsActions.set(reads))
  } catch (error) {
    console.error('Error fetching comment reads:', error)
  }
}
